import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';

import { toggleSwitch } from '../../actions/index';
import { _ } from '../../functions/translator.js';
import { ToggleActions } from '../../constants/constants.js';

class AxlesSwitch extends React.Component{

    handleOnClick = () => {
        this.props.toggleSwitch(ToggleActions.AXLES)
    };

    render() {
        return(
            <div>
                <FormGroup row>
                <FormControlLabel
                    className="text"
                    control={
                    <Switch
                        checked={ this.props.axles }
                        onChange={ this.handleOnClick }
                        color="primary"
                    />
                    }
                    label={ _('Mostrar Ejes') }
                />
                </FormGroup>
            </div>
        );
    } 
}

function mapStateToProps( state ){
    return {
        axles : state.switches.axles,
    }
}

function matchDispatchToProps( dispatch ){
    return bindActionCreators({ 
        toggleSwitch : toggleSwitch,
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(AxlesSwitch);